export var IBadge;
(function (IBadge) {
    let BadgeType;
    (function (BadgeType) {
        BadgeType["NEW_BADGE"] = "NEW_BADGE";
        BadgeType["HIGH_SELL_THROUGH"] = "HIGH_SELL_THROUGH";
        BadgeType["BESTSELLER"] = "BESTSELLER";
        BadgeType["TOP_SHOP"] = "TOP_SHOP";
        /**
         * @deprecated
         */
        BadgeType["PROMOTED"] = "PROMOTED";
        BadgeType["SHOWROOM"] = "SHOWROOM";
        BadgeType["PREVIOUSLY_ORDERED"] = "PREVIOUSLY_ORDERED";
        BadgeType["PREORDER"] = "PREORDER";
        /**
         * @deprecated
         */
        BadgeType["SAMPLED"] = "SAMPLED";
        /**
         * @deprecated
         */
        BadgeType["HIGH_SELL_THROUGH_V2"] = "HIGH_SELL_THROUGH_V2";
        /**
         * @deprecated
         */
        BadgeType["BESTSELLER_V2"] = "BESTSELLER_V2";
        /**
         * @deprecated
         */
        BadgeType["HIGH_SELL_THROUGH_V3"] = "HIGH_SELL_THROUGH_V3";
        BadgeType["BRAND_BESTSELLER"] = "BRAND_BESTSELLER";
        BadgeType["FAIRE_BESTSELLER"] = "FAIRE_BESTSELLER";
        /**
         * @deprecated
         */
        BadgeType["HIGH_SELL_THROUGH_V4"] = "HIGH_SELL_THROUGH_V4";
        /**
         * @deprecated
         */
        BadgeType["HIGH_SELL_THROUGH_V5"] = "HIGH_SELL_THROUGH_V5";
        BadgeType["HIGH_SELL_THROUGH_V6"] = "HIGH_SELL_THROUGH_V6";
        BadgeType["TRENDING"] = "TRENDING";
        /**
         * Backend only: should not be exposed to clients, should be converted to TRENDING if returned to clients.
         */
        BadgeType["INTERNAL_TRENDING_NAM"] = "INTERNAL_TRENDING_NAM";
        /**
         * Backend only: should not be exposed to clients, should be converted to TRENDING if returned to clients.
         */
        BadgeType["INTERNAL_TRENDING_EUROPE"] = "INTERNAL_TRENDING_EUROPE";
    })(BadgeType = IBadge.BadgeType || (IBadge.BadgeType = {}));
    /**
     * Return an instance of IBadge with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IBadge.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
})(IBadge || (IBadge = {}));
